var $ = jQuery;
$(document).ready(function(){
  if (window.location.href.includes('cart')){
    localStorage.setItem("cart-opened", "false");
  //  window.location.href = "/";
  }
  const is_cart = document.referrer;
  if (is_cart.includes("cart") && localStorage.getItem("cart-opened") === "false"){
    $(".open-cart-drawer").trigger("click"); 
    localStorage.setItem("cart-opened", "true");
  }
});